<div class="col-md-10 col-md-offset-1 container-visao-geral" [hidden]="(error && !success) || (!error && !success)">
  <div class="col-xs-12 first-line">
    <div class="col-md-12 col-lg-4 vendas-hoje">
        <div class="title">
          <span>Vendas </span>
          <span class="bold">Hoje</span>
        </div>
        <div class="container-valor-vendas-hoje">
          <div class="valor-vendas-hoje">
            <span>R$</span><span>{{ todayTotal.integer }},</span><span>{{ todayTotal.decimal }}</span>
          </div>
          <div class="total-do-mes">
            <span>Total do</span>
            <span class="bold">Mês</span>
            <span class="valor-total">
              <span>R$ </span><span>{{ monthTotal.integer }},</span><span>{{ monthTotal.decimal }}</span>
            </span>
          </div>
        </div>
    </div>
    <div class="col-md-12 col-lg-8 vendas-por-periodo">
      <div class="title">
        <span>Vendas por </span>
        <span class="bold">Período</span>
      </div>
      <div class="container-area-chart">
        <canvas id="area-chart"></canvas>
      </div>
    </div>
  </div>
  <div class="col-xs-12 second-line" *ngIf="account && account.TipoCadastro && account.TipoCadastro === 'PagueLa'">
    <div class="col-md-12 col-lg-6">
      <div class="card col-xs-12">
        <div class="title">
          <span>Lançamentos</span>
          <span class="bold">Futuros</span>
        </div>
        <div class="block">
          <span>7 Dias</span>
          <span *ngIf="dashboardData">{{ getFormatedCurrency(dashboardData.LancamentosFuturos.ValorTotal7Dias) }}</span>
        </div>
        <div class="block">
          <span>15 Dias</span>
          <span *ngIf="dashboardData">{{ getFormatedCurrency(dashboardData.LancamentosFuturos.ValorTotal15Dias) }}</span>
        </div>
        <div class="block">
          <span>30 Dias</span>
          <span *ngIf="dashboardData">{{ getFormatedCurrency(dashboardData.LancamentosFuturos.ValorTotal30Dias) }}</span>
        </div>
        <div class="total-lancamentos">
          <span>Total em</span>
          <span class="bold">Lançamentos</span>
          <span *ngIf="dashboardData">{{ getFormatedCurrency(dashboardData.LancamentosFuturos.ValorTotal7Dias + dashboardData.LancamentosFuturos.ValorTotal15Dias + dashboardData.LancamentosFuturos.ValorTotal30Dias) }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="col-md-10 col-md-offset-1 container-visao-geral" *ngIf="error && !success">
  <span class="error">Nenhuma informação disponível no momento</span>
  <span class="error">Tente novamente mais tarde</span>
</div>
